module.exports = __webpack_public_path__ + "slide3-package.5c4a78dd84be15307b91830b6223b679.hashedasset.svg";